// Module
var code = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.8337 9.1665H18.3337V10.8332H10.8337V18.3332H9.16699V10.8332H1.66699V9.1665H9.16699V1.6665H10.8337V9.1665Z\" fill=\"black\"/> </svg> ";
// Exports
module.exports = code;